import { render } from "./RecipeInstructions.vue?vue&type=template&id=0b20e138"
import script from "./RecipeInstructions.vue?vue&type=script&lang=js"
export * from "./RecipeInstructions.vue?vue&type=script&lang=js"

import "./RecipeInstructions.vue?vue&type=style&index=0&id=0b20e138&lang=css"

import exportComponent from "/var/www/staging.no-menu.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__